import React from 'react';
import './start.css'; // Importando o arquivo de estilos
import logo from "./assets/logo-basel.png"
import * as S from './styles';

const StarPage = ({onClick}) => {
  return (
    <div className="overlay">
      <S.DetailBoxClean>
        <img 
          src={logo} 
          alt="Carregando..." 
          className="image"
        />
        <S.DestaquePlus>Solicite seu táxi</S.DestaquePlus>
        <S.Texto1>Sem precisar de app. Toque para começar e tenha um táxi em minutos.</S.Texto1>
                  <S.PrimaryButton
                    onClick={() => {
                        onClick();
                    }}>
                    Tocar para solicitar
                  </S.PrimaryButton>
      </S.DetailBoxClean>
    </div>
  );
};

export default StarPage;